export const SET_PARTIDA = "SET_PARTIDA";
export const DELETE_PARTIDA = "DELETE_PARTIDA";
export const PARTIDAS_RECEIVED = "PARTIDAS_RECEIVED";
export const REORDENAR_PARTIDAS = "REORDENAR_PARTIDAS";
export const CREATE_NUEVA_PARTIDA = "CREATE_NUEVA_PARTIDA";
export const SET_PROPERTY_PARTIDA = "SET_PROPERTY_PARTIDA";
export const SET_PROPERTY_SINGLE_PARTIDA = "SET_PROPERTY_SINGLE_PARTIDA";
